export default "__VITE_ASSET__EhpiCqYA__"